export const sdLimitList = ['period_056_SD', 'period_057_SD', 'period_058_SD', 'period_061_GT']

// 操作记录要显示原因
export const showRecordReasonList = ['period_061_GT']

// 特殊的续保,续保需要分批的
export const specialInsureRenew = ['period_061_GT']